import {
  QueryObserverResult,
  RefetchOptions,
  RefetchQueryFilters,
} from '@tanstack/react-query';

export const localPrintPDF = async (
  createPDF: (
    options?: (RefetchOptions & RefetchQueryFilters<unknown>) | undefined
  ) => Promise<QueryObserverResult<string, Error>>,
  setIsLocalPrintLoading: (loading: boolean) => void,
  logError: (context: string, error: Error) => void
) => {
  setIsLocalPrintLoading(true);
  const blankWindow = window.open(
    '',
    '_blank',
    'location=yes,height=800,width=600'
  );
  if (!blankWindow) {
    setIsLocalPrintLoading(false);
    const error = new Error('popup_blocked');
    logError('Error generating pdf for report', error);
    return;
  }
  const generatingPdf = await createPDF();

  if (blankWindow.location) {
    blankWindow.location = generatingPdf?.data || '';
  }
  setIsLocalPrintLoading(false);
};
